import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import { connect } from 'react-redux';
import Input from '../common/FormComponents/InputStyle';
import Button from '../common/FormComponents/Button';
import { Mutation, compose } from 'react-apollo';
import { getp } from '../../helpers/getProp';
import gql from 'graphql-tag';
import Text from '../common/Text';
import { buildAvatarUrl } from './../../helpers/photoutils';
import Stepper from '../Stepper';
import { Whitespace } from '../common';
import ProfilePhoto from '../../components/ProfilePhoto/ProfilePhoto';
import {
  refreshUserVerification,
  resendEmailVerification,
  updateVerification,
} from '../../actions/manageUserVerification';
import history from '../../core/history';
import EmailVerification from './EmailVerification';
import ProfilePhotoVerification from './ProfilePhotoVerification';
import Checkbox from '../common/FormComponents/Checkbox';
import Link from '../../components/Link';

@observer
class Onboarding extends Component {
  @observable emailResent = false;
  @observable ageApproved = false;
  @observable termsApproved = false;
  nextRoute = null;

  onComplete = async () => {
    await this.props.updateVerification('onboarded');
    setTimeout(async () => {
      await this.props.refreshUserVerification();
      if (this.props.onCompleted) {
        this.props.onCompleted();
      }
    }, 250);
    if (this.nextRoute) {
      history.push(this.nextRoute);
    }
  };

  ////EMAIL
  resendEmail = async () => {
    const { client } = this.props;
    this.props.resendEmailVerification();
    this.emailResent = true;
  };

  checkEmail = async () => {
    await this.props.refreshUserVerification();
    return this.props.userStore.isEmailConfirmed;
  };

  goto = (route, next) => {
    this.nextRoute = route;
    next();
  };

  renderAgeCheck = () => {
    return {
      required: true,
      render: next => (
        <div className={containerStyles} id="onboarding-age-check">
          <Text h1 my={4} textAlign="center">
            Verify your age
          </Text>
          <div className="f-cc my-lxx">
            <i className="fa fa-check-circle fa-10x primary" />
          </div>
          <Checkbox
            onChange={val => (this.ageApproved = val)}
            checked={this.ageApproved}
            label="I verify that I am at least 18 years of age."
          />
          <Button
            onClick={next}
            primary
            className={`m-mxx`}
            disabled={!this.ageApproved}
          >
            Next
          </Button>
        </div>
      ),
    };
  };

  renderIntro = () => {
    return {
      required: true,
      render: next => (
        <div className={containerStyles} id="onboarding-intro">
          <Text h1 textAlign="center">
            Hi, {this.props.userStore.firstName}
          </Text>
          <Whitespace smaller2 />
          <Text t-lxx textAlign="center" grayDark>
            Welcome to
          </Text>
          <Whitespace medium />
          <div className="f-cc">
            <img src="/images/logo/blueRaw.png" width="200px" />
          </div>
          <Whitespace medium />
          <Text textAlign="center" noclip>
            Before you can list or rent items, we need to verify your identity.
            Let's get started!
          </Text>
          <Whitespace medium />
          <Button primary onClick={next} className="m-mxx">
            Next
          </Button>
        </div>
      ),
    };
  };
  renderPhoto = () => {
    return {
      required: false,
      render: next => (
        <ProfilePhotoVerification
          id="onboarding-photo"
          next={next}
          photo={this.props.userStore.picture}
        />
      ),
    };
  };
  renderEmail = () => {
    return {
      required: true,
      render: next => (
        <EmailVerification
          id="onboarding-email"
          next={next}
          userStore={this.props.userStore}
          resendEmail={this.resendEmail}
          emailResent={this.emailResent}
        />
      ),
    };
  };

  renderTerms = () => {
    return {
      required: true,
      render: next => (
        <div className={containerStyles} id="onboarding-terms">
          <Whitespace small />
          <Text h1 my={4} textAlign="center">
            Accept our terms
          </Text>
          <div className="f-cc my-lxx">
            <i className="fas fa-file-contract fa-10x primary" />
          </div>
          <Text h6>Read our</Text>{' '}
          <Link to={'https://www.yoodlize.com/policies'}>Terms of Service</Link>
          <Whitespace small />
          <Checkbox
            onChange={val => (this.termsApproved = val)}
            checked={this.termsApproved}
            label="I have read and accept the terms of service"
          />
          <Button
            onClick={next}
            className={`m-mxx`}
            disabled={!this.termsApproved}
            primary
          >
            Next
          </Button>
        </div>
      ),
    };
  };
  renderCompleted = () => {
    return {
      required: false,
      render: next => (
        <div className={containerStyles} id="onboarding-completed">
          <Text h1 my={4} textAlign="center">
            You’re all set!
          </Text>
          <Whitespace medium />
          <div className="f-cc">
            <i className="fas fa-check-circle fa-10x primary" />
          </div>
          <Whitespace medium />
          <Text textAlign="center" px={4} noclip>
            Congrats on joining the Yoodlize community. Dive in by adding a
            listing or looking around.
          </Text>
          <Whitespace small />
          <Button
            primary
            onClick={() => this.goto('/add-listing?mode=new', next)}
            className=""
            action
          >
            Add a listing
          </Button>
          <Whitespace smaller2 />
          <Button
            secondary
            muted
            onClick={() => this.goto('/', next)}
            className=""
            action
          >
            Browse
          </Button>
        </div>
      ),
    };
  };

  render() {
    const steps = [
      this.renderIntro(),
      this.renderEmail(),
      this.renderPhoto(),
      this.renderTerms(),
      this.renderCompleted(),
    ];
    if (
      this.props.userStore.isGoogleConnected ||
      this.props.userStore.isFacebookConnected
    ) {
      steps.splice(2, 1);
      steps.splice(1, 0, this.renderAgeCheck());
    }
    return (
      <div className="bg-white px-lxx py-s" forceInset={{ top: 'never' }}>
        <Stepper hasIntroStep steps={steps} onComplete={this.onComplete} />
      </div>
    );
  }
}

export default connect(
  state => {
    return {
      userStore: state.account.data,
    };
  },
  { refreshUserVerification, resendEmailVerification, updateVerification },
)(Onboarding);

const containerStyles = 'f f-center-stretch f-rows';



// WEBPACK FOOTER //
// ./src/components_new/verification/Onboarding.js